import { getLogger, sagaEffects, actions, } from '@signalwire/core';
export const sessionAuthWorker = function* (options) {
    getLogger().debug('sessionAuthWorker started');
    const { instance } = options;
    const action = yield sagaEffects.take([
        actions.authSuccessAction.type,
        actions.authErrorAction.type,
    ]);
    switch (action.type) {
        case actions.authSuccessAction.type:
            yield sagaEffects.call([instance, instance.resume]);
            break;
        case actions.authErrorAction.type:
            yield sagaEffects.call([instance, instance.setState], 'hangup');
            break;
    }
    getLogger().debug('sessionAuthWorker ended');
};
//# sourceMappingURL=sessionAuthWorker.js.map